import { defaultConfig, defineTokens } from '@chakra-ui/react';

const sizes = defineTokens.sizes({
    ...defaultConfig.theme?.tokens?.sizes,
    '1/3': { value: '33.33333333%' },
    '2/3': { value: '66.66666666%' },
});

export { sizes };
